module.exports = __webpack_public_path__ + "static/img/bg-image.05c4587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyao2025/bg-image.jpg
// module id = HPFz
// module chunks = 1